import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { storyClient } from '../client/storyClient';


type Options = {
  retry: boolean
};

const defaultOptions: Partial<Options> = {
  retry: false,
};

export const useStories = (params: Stories.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data }, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getStories, params],
    queryFn: () => storyClient.getStories(params),
    retry: options.retry !== undefined ? options.retry : defaultOptions.retry,
  });

  return {
    ...rest,
    absoluteTotal: data.absoluteTotal || 0,
    count: data.count || 0,
    stories: data.results || [],
  };
};
